import { css } from '@emotion/react';

import { SasIcon } from '../SasIcon';
import { theme } from '../theme';

const styles = {
  container: css`
    font-size: ${theme.fontSize.sm};
    font-weight: ${theme.fontWeight.bold};
    align-items: center;
    display: flex;
    gap: ${theme.spacing.xs};
    margin: 0;

    border-right: ${theme.borders.widths.md} solid ${theme.colors.lightBlue};
    padding-right: ${theme.spacing.md};
    margin-right: ${theme.spacing.md};

    @media (max-width: ${theme.breakpoints.tablet}) {
      padding-right: ${theme.spacing.sm};
      margin-right: ${theme.spacing.sm};
    }

    @media (max-width: ${theme.breakpoints.mobileS}) {
      font-size: ${theme.fontSize.xs};
    }
  `,
};

type Props = { icon: string; color: string; label: string };

export const VoucherStatus = ({ icon, color, label }: Props) => {
  const dimensions = { width: '24px', height: '24px' };

  return (
    <p css={styles.container}>
      <SasIcon name={icon} dimensions={dimensions} color={color} />
      <span>{label}</span>
    </p>
  );
};
